<template>
  <section>
    <div class="wrapper">
      <div class="main-panel">
        <!-- Customize Header -->
        <component :is="auth('admin').check() ? 'HeaderPage' : 'TeacherHeaderPage'" />
        <!-- Customize Header -->

        <div class="content">
          <slot />
        </div>
        <Footer />
      </div>
    </div>
  </section>
</template>

<script>
// Customize Header
import HeaderPage from "@/components/custom/layout/HeaderPage.vue";
import TeacherHeaderPage from "@/components/custom/layout/TeacherHeaderPage.vue";
import Footer from "@/components/layout/admin/FooterPage.vue";
import { mapState } from 'vuex';

export default {
  name: "MainLayout",
  components: {
    HeaderPage,
    Footer,
    TeacherHeaderPage
  },
  computed: {
    ...mapState({
      adminUser: state => state.user.admin_no,
      teacherNo: state => state.user.teacher_no,
      settingLoaded: state => state.settingLoaded
    })
  },
  methods: {
    refreshTeacherSessionRoles() {
      if (this.teacherNo) {
        this.$store.dispatch("refreshTeacherRoles");
      }
    },
  },
  mounted() {
    if (this.adminUser !== "0001" && !this.settingLoaded) {
      this.$store.dispatch("getSetting");
    }
    // Teacher menus depend on roleLabels cached at login; refresh so new
    // homeroom/assistant/subject assignments appear without re-login.
    this.refreshTeacherSessionRoles();
    document.addEventListener("visibilitychange", this.onVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
  },
  created() {
    this.onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        this.refreshTeacherSessionRoles();
      }
    };
  }
};
</script>
